// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "assets/" + chunkId + "." + {"743": "9f8c40fa","861": "eb0acd0b",}[chunkId] + ".js"
}